// let domen = 'api.ksrs.ru';
let domen = 'api.kcsni-service.ru';
let https = 'https';

if (process.env.NODE_ENV === 'development') {
  domen = '127.0.0.1:8001';
  https = 'http';
}
/// VERiFY URLS
export const DOMEN = `${https}://${domen}`;

// PROFILE
export const PROFILE_LIST_URL = `${https}://${domen}/api/users/profile/list/`;
export const PROFILE_ADMIN_DETAIL_URL = `${https}://${domen}/api/users/profile/admin-detail/`;
export const ALL_ORGANIZATIONS_URL = `${https}://${domen}/api/references/organization/list/`;


// PROPOSALS
export const PROPOSAL_VARIABLE_LIST_URL = `${https}://${domen}/api/proposals/proposal/variable_list/`;

export const REFERENCES_ALL_URL = `${https}://${domen}/api/references/all_list/`;


// INVITATION
export const GET_LIST_INVITATION_URL = `${https}://${domen}/api/proposals/invitation/list/`;
export const INVITATION_AVAILABLE_ACTIONS_URL = `${https}://${domen}/api/proposals/invitation/available_actions/`;



/// OLDS
export const AUTH_URL = `${https}://${domen}/accounts/`;
export const USER_URL = `${https}://${domen}/api/users/`;
export const UNSUBSCRIBE_URL = `${https}://${domen}/api/users/profile/unsubscribe/`;
export const REFERENCES_URL = `${https}://${domen}/api/references/`;
export const PROPOSAL_LIST_ROLE_BAGE_URL = `${https}://${domen}/api/proposals/proposal/list_role_bage/`;
export const EQUIMENT_URL = `${https}://${domen}/api/references/equipment/list/`;
export const INDIVIDUAL_URL = `${https}://${domen}/api/users/individual/list/`;
export const PROPOSAL_DETAIL_URL = `${https}://${domen}/api/proposals/proposal/detail/`;
export const FILE_POST_URL = `${https}://${domen}/api/references/file/detail/`;
export const FILES_LIST_URL = `${https}://${domen}/api/references/files/list/`;
export const CALENDAR_UPLOAD_URL = `${https}://${domen}/api/references/calendar/`;
export const REQUEST_URL = `${https}://${domen}/api/proposals/proposal/status/`;
export const PDF_URL = `${https}://${domen}/api/proposals/proposal/export/`;
export const EXPORT_LIST_TO_EXCEL_URL = `${https}://${domen}/api/proposals/proposal/export_list_excel/`;
export const ADD_COMMENT_BS_URL = `${https}://${domen}/api/proposals/comment/detail/`;
export const PROPOSAL_BS_ACTION_URL = `${https}://${domen}/api/proposals/bs/action/`;
export const ADD_EXPERIMENT_BS_URL = `${https}://${domen}/api/schedules/experiment/detail/`;

export const CALENDAR_LIST_URL = `${https}://${domen}/api/schedules/calendar/list_full/`;
export const STATION_WORKLOAD_URL = `${https}://${domen}/api/schedules/calendar/station_workload/`;
export const LANGUAGE_URL = `${https}://${domen}/api/users/profile/detail/`;
export const GET_USER_ID_URL = `${https}://${domen}/api/users/individual/detail/`;
export const SEARCH_MODERATOR_REQUEST_URL = `${https}://${domen}/api/proposals/proposal/search/`;
export const GET_LIST_ROLE_URL = `${https}://${domen}/api/proposals/old-proposal/list/`;
export const GET_LIST_ROLE_NEW_URL = `${https}://${domen}/api/proposals/expert-proposal-new/list/`;
export const GET_EXPERT_PROPOSAL_LIST_URL = `${https}://${domen}/api/proposals/expert-proposal/list/`;
export const GET_LIST_ARCHIVE_URL = `${https}://${domen}/api/proposals/proposal/archive/list/`;
export const PATCH_LIST_ARCHIVE_URL = `${https}://${domen}/api/proposals/proposal/archive/list/`;
export const BS_LIST_URL = `${https}://${domen}/api/users/profiles/bslist/`;
export const UPDATE_EXP_RESPONSIBLES_URL = `${https}://${domen}/api/schedules/calendar/exp_responsibles/`;
export const UPDATE_CALENDAR_REC_URL = `${https}://${domen}/api/schedules/calendar/detail/`;
export const DELETE_CALENDAR_REC_URL = `${https}://${domen}/api/schedules/calendar/delete/`;
export const CREATE_NEW_PROFILE_URL = `${https}://${domen}/api/users/profile/create/`;


// Статика
export const LOAD_EMAIL_LIST_URL = `${https}://${domen}/api/users/profile/emails_list/`;


// Proposals New
export const PROPOSAL_AVAILABLE_ACTIONS_URL = `${https}://${domen}/api/proposals/proposal/available_actions/`;
export const UPDATE_PROPOSAL_STATUS_URL = `${https}://${domen}/api/proposals/proposal/update_status/`;
export const MY_PROPOSALS_URL = `${https}://${domen}/api/proposals/proposal/my/`;
export const PROPOSAL_EXPERTS_URL = `${https}://${domen}/api/proposals/proposal/proposal_experts/`;
export const SAMPLETYPES_URL = `${https}://${domen}/api/proposals/proposal/sample_types/`;
export const PROPOSAL_CHANGE_TEAM_URL = `${https}://${domen}/api/proposals/proposal/add_to_team/`;

// Councils
export const GET_LIST_COUNCILS_URL = `${https}://${domen}/api/proposals/councils/list/`;
export const COUNCIL_CHANGE_STATUS_URL = `${https}://${domen}/api/proposals/councils/change_status/`;
export const NEW_COUNCIL_URL = `${https}://${domen}/api/proposals/councils/create/`;
export const COUNCIL_DETAIL_URL = `${https}://${domen}/api/proposals/councils/detail/`;
export const CHANGE_COUNCIL_PROPOSALS_URL = `${https}://${domen}/api/proposals/councils/change_proposals/`;
export const CHANGE_COUNCIL_PROPOSAL_EXPERTS_URL = `${https}://${domen}/api/proposals/councils/change_proposal_experts/`;
export const CHANGE_COUNCIL_PROPOSAL_SOLUTION_URL = `${https}://${domen}/api/proposals/councils/change_proposal_solution/`;
export const NEXT_COUNCIL_STATUS_URL = `${https}://${domen}/api/proposals/councils/next_status/`;
export const COUNCIL_EXPORT_TO_DOCX_URL = `${https}://${domen}/api/proposals/council/export_word/`;
export const UPDATE_COUNCIL_TIME_URL = `${https}://${domen}/api/proposals/council/update_time/`;
export const UPDATE_EXPERT_COUNCIL_RESOLUTION_URL = `${https}://${domen}/api/proposals/council/update_expert_resolution/`;
export const CHANGE_COUNCIL_TEAM_URL = `${https}://${domen}/api/proposals/councils/change_team/`;
export const SAVE_STATION_TIME_AVAILABLE_URL = `${https}://${domen}/api/proposals/councils/save_time_available/`;


// PASSES
export const GET_LIST_PASSES_URL = `${https}://${domen}/api/proposals/passes/list/`;
export const PASS_ACTION_URL = `${https}://${domen}/api/proposals/pass/action/`;
export const PASS_AVAILABLE_ACTIONS_URL = `${https}://${domen}/api/proposals/pass/available_actions/`;


export const GET_ACTION_HISTORY_URL = `${https}://${domen}/api/proposals/action/history/`;

export const EXPORT_CALENDAR_EXCEL_URL = `${https}://${domen}/api/proposals/calendar/export_calendar_excel/`;
